import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SharedDocumentsAGNotesReportService } from '@app/shared/services/shared-documents-ag-notes-report.service';
import { ShellService } from '@mynexus/mfe-core';
import { ProductNames } from '@mynexus/mynexus-ui-lib';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DocumentsAGNotesReportHHService extends SharedDocumentsAGNotesReportService {

  constructor(
    http: HttpClient,
    shellService: ShellService
  ) {
    super(http, shellService, ProductNames.HomeHealth);
  }

  override downloadAGNotes(tenantId: string, authorizationByProductId: string, lineIds: object[]): Observable<string> {
    return this.http.post(`${this.API_URL}/DownloadAGNotes/${tenantId}/${authorizationByProductId}`, lineIds, { responseType: 'text' });
  }

  override getInformationMessage(): string {
    return 'Please select the Service Line(s) to generate the A&G Notes Report.';
  }
}
